<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()"
        ><i class="fal fa-times-circle fa-lg"></i
      ></span>
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
      >
        <li class="nav-item m-tabs__item">
          <a class="nav-link m-tabs__link active" data-toggle="tab" href="#save_scope" role="tab">
            <h5><span class="far fa-address-card"></span> Editar Escopo</h5>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="save_scope" role="tabpanel">
          <ScopeSaveForm />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScopeSaveForm from '@/components/users/manager/scopes/ScopeSaveForm';

export default {
  name: 'ScopeSave',
  components: { ScopeSaveForm },
  methods: {
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showScopeSave = null;
    },
  },
  computed: {
    scopeId() {
      return this.$store.state.showScopeSave;
    },
  },
};
</script>
